import type {
  ConditionKind,
  TreeConditionNode,
} from '@/components/tree-dnd/tree-dnd-types';
import { createDefaultConditionNode } from '@/components/tree-dnd/tree-dnd-conditions/condition-defaults';

type ConditionDefinition<K extends ConditionKind> = {
  kind: K;
  createDefault: () => Extract<TreeConditionNode, { kind: K }>;
};

export const CONDITION_REGISTRY: {
  [K in ConditionKind]: ConditionDefinition<K>;
} = {
  installedApp: {
    kind: 'installedApp',
    createDefault: () => createDefaultConditionNode('installedApp'),
  },
  boughtProduct: {
    kind: 'boughtProduct',
    createDefault: () => createDefaultConditionNode('boughtProduct'),
  },
  receivedNotification: {
    kind: 'receivedNotification',
    createDefault: () => createDefaultConditionNode('receivedNotification'),
  },
  clickedCampaign: {
    kind: 'clickedCampaign',
    createDefault: () => createDefaultConditionNode('clickedCampaign'),
  },
  rfmGroup: {
    kind: 'rfmGroup',
    createDefault: () => createDefaultConditionNode('rfmGroup'),
  },
  lastNotificationAt: {
    kind: 'lastNotificationAt',
    createDefault: () => createDefaultConditionNode('lastNotificationAt'),
  },
  lastAppAccessAt: {
    kind: 'lastAppAccessAt',
    createDefault: () => createDefaultConditionNode('lastAppAccessAt'),
  },
  viewedProduct: {
    kind: 'viewedProduct',
    createDefault: () => createDefaultConditionNode('viewedProduct'),
  },
  location: {
    kind: 'location',
    createDefault: () => createDefaultConditionNode('location'),
  },
  lastOrder: {
    kind: 'lastOrder',
    createDefault: () => createDefaultConditionNode('lastOrder'),
  },
  orderFrequency: {
    kind: 'orderFrequency',
    createDefault: () => createDefaultConditionNode('orderFrequency'),
  },
  totalSpend: {
    kind: 'totalSpend',
    createDefault: () => createDefaultConditionNode('totalSpend'),
  },
  hasNotificationsEnabled: {
    kind: 'hasNotificationsEnabled',
    createDefault: () => createDefaultConditionNode('hasNotificationsEnabled'),
  },
};

export const CONDITION_KINDS = Object.keys(
  CONDITION_REGISTRY
) as ConditionKind[];

/** Hidden from filter pickers until API support lands. */
export const HIDDEN_CONDITION_KINDS = new Set<ConditionKind>([
  'rfmGroup',
  'location',
]);

export const VISIBLE_CONDITION_KINDS = CONDITION_KINDS.filter(
  (kind) => !HIDDEN_CONDITION_KINDS.has(kind)
);
